import { commonModules } from '.';

export const srcPath = (fileName) => {
  const { config } = commonModules;
  return fileName && `${config.baseUrl}${config.getSrcFile}/${fileName.replace(/\\/g, '/')}`;
};